import { useState, useEffect } from 'react';
import { hashtagsAPI } from './api';

// Cache module-level du catalogue des hashtags (id -> {label, color}).
// Évite de refetcher le catalogue pour chaque ligne/carte de dossier.
let _cache = null;       // { [id]: { label, color } }
let _promise = null;

export function loadHashtagCatalog(force = false) {
    if (_cache && !force) return Promise.resolve(_cache);
    if (_promise && !force) return _promise;
    _promise = hashtagsAPI.list()
        .then((r) => {
            const map = {};
            (r.data || []).forEach((h) => { map[h.id] = { label: h.label, color: h.color }; });
            _cache = map;
            return map;
        })
        .catch(() => ({}))
        .finally(() => { _promise = null; });
    return _promise;
}

// Invalide le cache (à appeler après création/suppression d'un hashtag).
export function invalidateHashtagCatalog() { _cache = null; _promise = null; }

export function useHashtagCatalog() {
    const [catalog, setCatalog] = useState(_cache || {});
    useEffect(() => {
        let mounted = true;
        loadHashtagCatalog().then((map) => { if (mounted) setCatalog(map); });
        return () => { mounted = false; };
    }, []);
    return catalog;
}
